/* document.querySelectorAll('.nodes') */
const $all = (nodes) => [...document.querySelectorAll(nodes)]

/* parent.querySelector('#panel'); */
const $one = (node, parent) => (parent ? parent : document).querySelector(node)

export {
  $all,
  $one
}